import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b312eb00&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b312eb00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b312eb00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CouponItem: require('/drone/src/components/CouponItem/index.vue').default})
